















import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({})
export default class ToolbarToogleIconButton extends Vue {
  //TODO: как-то улучшить!
  @Prop({required: true})
  activeState!: number | null | undefined;
  get actState() {
    return this.activeState;
  }
  set actState(value: number | null | undefined) {
    this.$emit('actChange', {value, active: value != null});
  }

  @Prop({required: true, type: String, default: ''})
  tooltip!: string;

  @Prop({type: Boolean, default: false})
  disabled!: string;

  @Prop({type: Number, default: 0})
  degreeRotateIcon!: number;

  @Prop({default: () => ({})})
  activators!: {};

  click(e: any) {
    this.$emit('click', e);
  }
}
